import { render, staticRenderFns } from "./ConsumerCurveItem.vue?vue&type=template&id=482dc9da&scoped=true&"
import script from "./ConsumerCurveItem.vue?vue&type=script&lang=js&"
export * from "./ConsumerCurveItem.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerCurveItem.vue?vue&type=style&index=0&id=482dc9da&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482dc9da",
  null
  
)

export default component.exports